<tidy-card>
  <tidy-card-button (action)="goToCreateConciergeAction()">
    <ion-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/csv.svg'"
          style="width:20px" />
      </tidy-row>
      <ion-col>
        <tidy-row>
          <tidy-text
            [header]="'Upload Your Items'" />
        </tidy-row>
      </ion-col>
    </ion-row>
  </tidy-card-button>
</tidy-card>

<tidy-card>
  <tidy-card-button (action)="goToUploadInventoryList()">
    <ion-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/add-items.svg'"
          style="width:20px" />
      </tidy-row>
      <ion-col>
        <tidy-row>
          <tidy-text
            [header]="'Add Items Manually'" />
        </tidy-row>
      </ion-col>
    </ion-row>
  </tidy-card-button>
</tidy-card>

<tidy-card>
  <tidy-card-button (action)="prosAddFromChecklist()">
    <ion-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/todos.svg'"
          style="width:20px" />
      </tidy-row>
      <ion-col>
        <tidy-row>
          <tidy-text
            [header]="'Pros Add from Checklist'" />
        </tidy-row>
      </ion-col>
    </ion-row>
  </tidy-card-button>
</tidy-card>

<tidy-card class="no-margin-bottom">
  <tidy-card-button (action)="startWithPopular()">
    <ion-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/star.svg'"
          style="width:20px" />
      </tidy-row>
      <ion-col>
        <tidy-row>
          <tidy-text
            [header]="'Start with Most Popular'" />
        </tidy-row>
      </ion-col>
    </ion-row>
  </tidy-card-button>
</tidy-card>